package com.schoolconnect.app.feature.itusers

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.chevron_left
import ischoolconnect.sharedui.generated.resources.chevron_right
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.search
import ischoolconnect.sharedui.generated.resources.refresh_cw
import ischoolconnect.sharedui.generated.resources.sort
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.painterResource
import com.schoolconnect.app.designsystem.list.AdminInfoBanner
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListPagination
import com.schoolconnect.app.designsystem.list.AdminListRowsPerPageButton
import com.schoolconnect.app.designsystem.list.AdminListRowActionBar
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListToolbar
import com.schoolconnect.app.designsystem.list.AdminListToolbarButton
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardItem
import com.schoolconnect.app.designsystem.list.AdminStandardRowActionMenu
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppInputBorder
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.AppLine
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppPurpleSoft
import com.schoolconnect.app.designsystem.AppPurpleText
import com.schoolconnect.app.designsystem.AppSecondaryBackground
import com.schoolconnect.app.designsystem.AppSoftSurface
import com.schoolconnect.app.designsystem.AdminSummaryMetrics
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppInfoText

internal val ITUsersBackground = AppSecondaryBackground
internal val ITUsersSurface = AppSurface
internal val ITUsersBorder = AppBorder
internal val ITUsersLine = AppLine
internal val ITUsersNavy = AppNavy
internal val ITUsersMuted = AppMuted
internal val ITUsersPrimary = AppPrimary
internal val ITUsersSuccess = AppSuccess
internal val ITUsersSuccessBg = AppSuccessSoft
internal val ITUsersDanger = AppDanger
internal val ITUsersDangerBg = AppDangerSoft
internal val ITUsersPurpleBg = AppPurpleSoft
internal val ITUsersPurpleText = AppPurpleText
internal val ITUsersBlueBg = AppPrimarySoft
internal val ITUsersBlueText = AppInfoText
internal val ITUsersInputBorder = AppInputBorder

@Composable
internal fun ITUsersSummaryCard(
    title: String,
    value: String,
    subtitle: String,
    icon: Painter,
    iconTint: Color,
    iconBg: Color,
    subtitleColor: Color,
    modifier: Modifier = Modifier
) {
    Card(
        modifier = modifier.height(128.dp),
        shape = RoundedCornerShape(10.dp),
        colors = CardDefaults.cardColors(containerColor = ITUsersSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, ITUsersBorder)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 22.dp, vertical = 22.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(20.dp)
        ) {
            Box(
                modifier = Modifier
                    .size(70.dp)
                    .background(iconBg, RoundedCornerShape(10.dp)),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = icon,
                    contentDescription = title,
                    tint = iconTint,
                    modifier = Modifier.size(34.dp)
                )
            }
            Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                Text(
                    text = title,
                    style = MaterialTheme.typography.bodyMedium.copy(fontSize = 14.sp),
                    color = ITUsersNavy,
                    fontWeight = FontWeight.Bold
                )
                Text(
                    text = value,
                    style = MaterialTheme.typography.headlineSmall.copy(fontSize = 30.sp),
                    color = ITUsersNavy,
                    fontWeight = FontWeight.ExtraBold,
                    letterSpacing = (-0.02).sp
                )
                Text(
                    text = subtitle,
                    style = MaterialTheme.typography.bodySmall.copy(fontSize = 13.sp),
                    color = subtitleColor,
                    fontWeight = FontWeight.SemiBold
                )
            }
        }
    }
}

@Composable
internal fun itUsersSummaryItems(
    totalUsers: Int,
    activeUsers: Int,
    inactiveUsers: Int,
    scopeLabel: String?
): List<AdminListSummaryCardItem> = listOf(
    AdminListSummaryCardItem(
        title = "Total IT Users",
        value = totalUsers.toString(),
        subtitle = scopeLabel?.takeIf { it.isNotBlank() }?.let { "Scope: $it" } ?: "Platform-wide total",
        icon = painterResource(Res.drawable.users),
        accent = AdminSummaryMetrics.ItUsers.accent,
        accentBg = AdminSummaryMetrics.ItUsers.soft,
        subtitleColor = ITUsersMuted,
        surfaceColor = ITUsersSurface,
        borderColor = ITUsersBorder,
        textColor = ITUsersNavy
    ),
    AdminListSummaryCardItem(
        title = "Active IT Users",
        value = activeUsers.toString(),
        subtitle = percentageSubtitle(activeUsers, totalUsers),
        icon = painterResource(Res.drawable.circle_check),
        accent = AdminSummaryMetrics.StatusActive.accent,
        accentBg = AdminSummaryMetrics.StatusActive.soft,
        subtitleColor = AdminSummaryMetrics.StatusActive.accent,
        surfaceColor = ITUsersSurface,
        borderColor = ITUsersBorder,
        textColor = ITUsersNavy
    ),
    AdminListSummaryCardItem(
        title = "Inactive Users",
        value = inactiveUsers.toString(),
        subtitle = percentageSubtitle(inactiveUsers, totalUsers),
        icon = painterResource(Res.drawable.ban),
        accent = AdminSummaryMetrics.StatusInactive.accent,
        accentBg = AdminSummaryMetrics.StatusInactive.soft,
        subtitleColor = AdminSummaryMetrics.StatusInactive.accent,
        surfaceColor = ITUsersSurface,
        borderColor = ITUsersBorder,
        textColor = ITUsersNavy
    )
)

internal fun percentageSubtitle(value: Int, total: Int): String {
    if (total <= 0) return "0%"
    val pct = ((value.toDouble() / total.toDouble()) * 100.0).toInt().coerceIn(0, 100)
    return "$pct%"
}

@Composable
internal fun ITUsersToolbar(
    searchQuery: String,
    onSearchQueryChanged: (String) -> Unit,
    roleFilter: String,
    statusFilter: String,
    onRoleFilterChanged: (String) -> Unit,
    onStatusFilterChanged: (String) -> Unit,
    onResetClick: () -> Unit,
    onFilterClick: () -> Unit
) {
    AdminListToolbar(
        searchQuery = searchQuery,
        onSearchQueryChanged = onSearchQueryChanged,
        searchPlaceholder = "Search by name, mobile or email...",
        searchWidth = 320.dp,
        height = 48.dp,
        surfaceColor = ITUsersSurface,
        borderColor = ITUsersBorder,
        searchIconTint = ITUsersMuted,
        searchTextColor = ITUsersNavy,
        searchCursorColor = ITUsersPrimary,
        inlineContent = {
            AppLabeledDropdownField(
                label = "",
                value = roleFilter.ifBlank { "All Roles" },
                options = itUserRoleOptions,
                onSelected = onRoleFilterChanged,
                modifier = Modifier.width(168.dp),
                allOptionLabel = "All Roles"
            )
            AppLabeledDropdownField(
                label = "",
                value = statusFilter.ifBlank { "All Statuses" },
                options = itUserStatusOptions,
                onSelected = onStatusFilterChanged,
                modifier = Modifier.width(148.dp),
                allOptionLabel = "All Statuses"
            )
        }
    ) {
        AdminListToolbarButton(
            label = "Reset",
            icon = painterResource(Res.drawable.refresh_cw),
            onClick = onResetClick,
            width = 112.dp,
            borderColor = ITUsersPrimary,
            contentColor = ITUsersPrimary,
            iconSize = 18.dp
        )
        AdminListToolbarButton(
            label = "More Filters",
            icon = painterResource(Res.drawable.filter),
            onClick = onFilterClick,
            width = 148.dp,
            borderColor = ITUsersPrimary,
            contentColor = ITUsersPrimary,
            iconSize = 18.dp
        )
    }
}

@Composable
private fun ITUsersSearchField(
    value: String,
    onValueChange: (String) -> Unit
) {
    AdminListSearchField(
        value = value,
        onValueChange = onValueChange,
        placeholder = "Search by name, mobile or email...",
        width = 420.dp,
        surfaceColor = ITUsersSurface,
        borderColor = ITUsersBorder,
        iconTint = ITUsersMuted,
        textColor = ITUsersNavy,
        cursorColor = ITUsersPrimary
    )
}

@Composable
private fun ITUsersToolbarButton(
    label: String,
    icon: Painter,
    onClick: () -> Unit,
    width: Dp
) {
    AdminListToolbarButton(
        label = label,
        icon = icon,
        onClick = onClick,
        width = width,
        borderColor = ITUsersBorder,
        contentColor = ITUsersPrimary,
        iconSize = 18.dp
    )
}

@Composable
internal fun ITUsersTableCard(
    modifier: Modifier = Modifier,
    sortField: ITUsersSortField,
    sortAscending: Boolean,
    items: List<ITUserRowUi>,
    isLoading: Boolean,
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    pageSize: Int,
    openActionMenuUserId: String?,
    onToggleActionMenu: (String) -> Unit,
    onCloseActionMenu: (String) -> Unit,
    onSortChanged: (ITUsersSortField) -> Unit,
    onViewUser: (String) -> Unit,
    onEditUser: (String) -> Unit,
    onToggleStatus: (String) -> Unit,
    onDeleteUser: (String) -> Unit,
    rowsPerPageExpanded: Boolean,
    onRowsPerPageToggle: () -> Unit,
    onRowsPerPageDismiss: () -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    onPageChanged: (Int) -> Unit
) {
    AdminListTableCard(
        modifier = modifier.fillMaxSize(),
        minContentWidth = 1100.dp,
        surfaceColor = ITUsersSurface,
        borderColor = ITUsersBorder,
        header = {
            ITUsersTableHeader(
                sortField = sortField,
                sortAscending = sortAscending,
                onSortChanged = onSortChanged
            )
        },
        body = {
            if (isLoading) {
                AdminListTableShimmer(
                    columns = itUsersTableShimmerColumns(),
                    rowCount = 6,
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f),
                    rowHeight = 51.dp,
                    verticalPadding = 0.dp,
                    surfaceColor = ITUsersSurface,
                    borderColor = ITUsersBorder
                )
            } else if (items.isEmpty()) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = "No users found",
                        color = ITUsersNavy,
                        fontWeight = FontWeight.Bold
                    )
                }
            } else {
                AdminListTableBody(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f),
                    items = items,
                    key = { it.id }
                ) { user ->
                    ITUsersRow(
                        user = user,
                        isActionMenuOpen = openActionMenuUserId == user.id,
                        onActionMenuToggle = { onToggleActionMenu(user.id) },
                        onActionMenuDismiss = { onCloseActionMenu(user.id) },
                        onViewUser = { onViewUser(user.id) },
                        onEditUser = { onEditUser(user.id) },
                        onToggleStatus = { onToggleStatus(user.id) },
                        onDeleteUser = { onDeleteUser(user.id) }
                    )
                    }
            }
        },
        footer = {
            ITUsersFooter(
                pageText = pageText,
                pageIndex = pageIndex.coerceAtMost(maxOf(0, pageCount - 1)),
                pageCount = pageCount,
                pageSize = pageSize,
                rowsPerPageExpanded = rowsPerPageExpanded,
                onRowsPerPageToggle = onRowsPerPageToggle,
                onRowsPerPageDismiss = onRowsPerPageDismiss,
                onPageSizeChanged = onPageSizeChanged,
                onPageChanged = onPageChanged
            )
        }
    )
}

internal fun itUsersTableShimmerColumns(): List<AdminListHeaderColumn> = listOf(
    AdminListHeaderColumn(label = "User", weight = 1.3f),
    AdminListHeaderColumn(label = "Mobile", weight = 1f),
    AdminListHeaderColumn(label = "Email", weight = 1.6f),
    AdminListHeaderColumn(label = "Role", weight = 0.95f),
    AdminListHeaderColumn(label = "Created On", weight = 1.05f),
    AdminListHeaderColumn(label = "Status", weight = 0.85f),
    AdminListHeaderColumn(label = "Actions", weight = 0.95f)
)

@Composable
private fun ITUsersTableHeader(
    sortField: ITUsersSortField,
    sortAscending: Boolean,
    onSortChanged: (ITUsersSortField) -> Unit
) {
    AdminListSortHeaderRow(
        columns = listOf(
            AdminListSortColumn(
                label = "User",
                weight = 1.3f,
                selected = sortField == ITUsersSortField.USER,
                ascending = sortAscending,
                onClick = { onSortChanged(ITUsersSortField.USER) }
            ),
            AdminListSortColumn(
                label = "Mobile",
                weight = 1f,
                selected = sortField == ITUsersSortField.MOBILE,
                ascending = sortAscending,
                onClick = { onSortChanged(ITUsersSortField.MOBILE) }
            ),
            AdminListSortColumn(
                label = "Email",
                weight = 1.6f,
                selected = sortField == ITUsersSortField.EMAIL,
                ascending = sortAscending,
                onClick = { onSortChanged(ITUsersSortField.EMAIL) }
            ),
            AdminListSortColumn(
                label = "Role",
                weight = 0.95f,
                selected = sortField == ITUsersSortField.ROLE,
                ascending = sortAscending,
                onClick = { onSortChanged(ITUsersSortField.ROLE) }
            ),
            AdminListSortColumn(
                label = "Created On",
                weight = 1.05f,
                selected = sortField == ITUsersSortField.CREATED_ON,
                ascending = sortAscending,
                onClick = { onSortChanged(ITUsersSortField.CREATED_ON) }
            ),
            AdminListSortColumn(
                label = "Status",
                weight = 0.85f,
                selected = sortField == ITUsersSortField.STATUS,
                ascending = sortAscending,
                onClick = { onSortChanged(ITUsersSortField.STATUS) }
            )
        ),
        actionsWeight = 0.95f
    )
}

@Composable
internal fun ITUsersRow(
    user: ITUserRowUi,
    isActionMenuOpen: Boolean,
    onActionMenuToggle: () -> Unit,
    onActionMenuDismiss: () -> Unit,
    onViewUser: () -> Unit,
    onEditUser: () -> Unit,
    onToggleStatus: () -> Unit,
    onDeleteUser: () -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .onViewDoubleClick(onViewUser)
            .height(52.dp)
            .padding(horizontal = 24.dp)
    ) {
        HorizontalDivider(color = ITUsersLine)
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(modifier = Modifier.weight(1.3f)) {
                AdminListTableBodyText(
                    text = user.name,
                    color = ITUsersNavy
                )
            }
            Box(modifier = Modifier.weight(1f)) {
                AdminListTableBodyText(
                    text = user.mobile,
                    color = ITUsersNavy
                )
            }
            Box(modifier = Modifier.weight(1.6f)) {
                AdminListTableBodyText(
                    text = user.email,
                    color = ITUsersNavy
                )
            }
            Box(modifier = Modifier.weight(0.95f)) {
                ITUsersRoleBadge(role = user.role)
            }
            Box(modifier = Modifier.weight(1.05f)) {
                AdminListTableBodyText(
                    text = user.createdOn.ifBlank { "—" },
                    color = ITUsersNavy
                )
            }
            Box(modifier = Modifier.weight(0.85f)) {
                ITUsersStatusBadge(status = user.status)
            }
            Box(
                modifier = Modifier.weight(0.95f),
                contentAlignment = Alignment.CenterStart
            ) {
                AdminListRowActionBar(
                    isActive = user.status == ITUserStatusUi.ACTIVE,
                    expanded = isActionMenuOpen,
                    onExpandedChange = { onActionMenuToggle() },
                    onDismissRequest = onActionMenuDismiss,
                    onView = onViewUser,
                    onEdit = onEditUser,
                    onToggleStatus = onToggleStatus,
                    onDelete = onDeleteUser,
                    width = 190.dp,
                    surfaceColor = ITUsersSurface,
                    borderColor = ITUsersBorder
                )
            }
        }
    }
}

@Composable
internal fun ITUsersActionMenu(
    onDismissRequest: () -> Unit,
    isActive: Boolean,
    onViewUser: () -> Unit,
    onEditUser: () -> Unit,
    onToggleStatus: () -> Unit,
    onDeleteUser: () -> Unit
) {
    AdminStandardRowActionMenu(
        isActive = isActive,
        onDismissRequest = onDismissRequest,
        onView = onViewUser,
        onEdit = onEditUser,
        onToggleStatus = onToggleStatus,
        onDelete = onDeleteUser,
        width = 190.dp,
        surfaceColor = ITUsersSurface,
        borderColor = ITUsersBorder
    )
}

@Composable
internal fun ITUsersRoleBadge(role: ITUserRoleUi?) {
    val label = when (role) {
        ITUserRoleUi.SUPER_ADMIN -> "IT Super Admin"
        ITUserRoleUi.IT_ADMIN -> "IT Admin"
        ITUserRoleUi.IT_SUPPORT -> "IT Support"
        null -> "—"
    }
    AdminListTableBodyText(text = label, color = ITUsersNavy)
}

@Composable
internal fun ITUsersStatusBadge(status: ITUserStatusUi) {
    val (label, textColor) = when (status) {
        ITUserStatusUi.ACTIVE -> "Active" to ITUsersSuccess
        ITUserStatusUi.INACTIVE -> "Inactive" to ITUsersDanger
    }
    Text(
        text = label,
        color = textColor,
        fontSize = 14.sp,
        fontWeight = FontWeight.Normal
    )
}

@Composable
internal fun ITUsersFooter(
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    pageSize: Int,
    rowsPerPageExpanded: Boolean,
    onRowsPerPageToggle: () -> Unit,
    onRowsPerPageDismiss: () -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    onPageChanged: (Int) -> Unit
) {
    AdminListFooter(
        pageText = pageText,
        pageIndex = pageIndex,
        pageCount = pageCount,
        onPageChanged = onPageChanged,
        pageSize = pageSize,
        rowsPerPageExpanded = rowsPerPageExpanded,
        onRowsPerPageToggle = onRowsPerPageToggle,
        onRowsPerPageDismiss = onRowsPerPageDismiss,
        onPageSizeChanged = onPageSizeChanged,
        borderColor = ITUsersBorder,
        footerColor = ITUsersMuted,
        height = 56.dp,
        horizontalPadding = 24.dp,
        pageSizeHeight = 40.dp
    )
}

@Composable
internal fun ITUsersPagination(
    pageIndex: Int,
    pageCount: Int,
    onPageChanged: (Int) -> Unit
) {
    AdminListPagination(
        pageIndex = pageIndex,
        pageCount = pageCount,
        onPageChanged = onPageChanged,
        borderColor = ITUsersBorder,
        surfaceColor = ITUsersSurface,
        primaryColor = ITUsersPrimary,
        navyColor = ITUsersNavy,
        mutedColor = ITUsersMuted
    )
}

@Composable
private fun ITUsersCircleButton(
    icon: Painter,
    enabled: Boolean,
    onClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .size(28.dp)
            .background(ITUsersSurface, RoundedCornerShape(100))
            .border(1.dp, ITUsersBorder, RoundedCornerShape(100))
            .clickable(enabled = enabled, onClick = onClick),
        contentAlignment = Alignment.Center
    ) {
        Icon(
            painter = icon,
            contentDescription = null,
            tint = if (enabled) ITUsersMuted else ITUsersBorder,
            modifier = Modifier.size(16.dp)
        )
    }
}

@Composable
internal fun ITUsersAddButton(
    onClick: () -> Unit
) {
    Row(
        modifier = Modifier
            .width(138.dp)
            .height(40.dp)
            .background(ITUsersPrimary, RoundedCornerShape(8.dp))
            .clickable(onClick = onClick)
            .padding(horizontal = 12.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Icon(
            painter = painterResource(Res.drawable.plus),
            contentDescription = null,
            tint = Color.White,
            modifier = Modifier.size(18.dp)
        )
        Spacer(modifier = Modifier.width(6.dp))
        Text(
            text = "Add IT User",
            color = Color.White,
            fontSize = 13.sp,
            fontWeight = FontWeight.ExtraBold,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}
